import React, { PropsWithChildren } from 'react';
import { GlobalDocumentIds } from '../../../../types/GlobalDocumentIds';

/**
 * WARNING: do not remove or change this!
 * tabindex is set to -1 here, so we can focus this programmatically while routing.
 * SEE useGenericPage as well!
 */
export function PageLeadHeadline({ children }: PropsWithChildren) {
  return (
    <h1 id={GlobalDocumentIds.pageTitle} className="page-lead__headline" tabIndex={-1}>
      {children}
    </h1>
  );
}
